import { notification } from "antd";
import { makeAutoObservable } from "mobx";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";
import { FileType, ZUploadResult, ZImportStatus } from "./types";
import { uploadEntityFile, checkImportStatus } from "./apiEntityImport";

export class EntityImportButtonStore {
  result: ZUploadResult | null = null;

  setResult(value: ZUploadResult | null) {
    this.result = value;
  }

  loading = false;

  setLoading(value: boolean) {
    this.loading = value;
  }

  open = false;

  setOpen(value: boolean) {
    this.open = value;
  }

  importStatus: ZImportStatus | null = null;

  setImportStatus(value: ZImportStatus | null) {
    this.importStatus = value;
  }

  checkingStatus = false;

  setCheckingStatus(value: boolean) {
    this.checkingStatus = value;
  }

  constructor(readonly objectId: ZUid) {
    makeAutoObservable(this);
  }

  async init() {
    this.setLoading(false);
    this.setOpen(false);
    this.setResult(null);
    this.setImportStatus(null);
  }

  async checkCurrentImportStatus() {
    this.setCheckingStatus(true);
    try {
      const status = await checkImportStatus();
      this.setImportStatus(status);
    } catch (e) {
      onError(e);
    } finally {
      this.setCheckingStatus(false);
    }
  }

  async uploadFile(file: FileType) {
    this.setLoading(true);
    try {
      const result = await uploadEntityFile(this.objectId, file);
      this.setResult(result);
      if (result.status === "success") {
        this.setOpen(false);
        notification.success({ message: result.description });
      }
    } catch (e) {
      onError(e);
    } finally {
      this.setLoading(false);
    }
  }
}
